import VehicleCard from './SideBar';

export default VehicleCard;
